import { RootState } from "src/store";

import { devicesAdapter } from "@dashboard/devices/store/helpers";
import type { Device, License } from "@dashboard/devices/types";
import { selectLicensesByGroupId, selectLicensesByGroupIds } from "@dashboard/licenses/store/selectors";
import { createSelector } from "@reduxjs/toolkit";

const defaultSelectors = devicesAdapter.getSelectors<RootState>((state) => state.devices.list.devices.items);
const selectDeviceById = defaultSelectors.selectById;
const emptyDevices: Device[] = [];

const selectDevicesByGroupIds = createSelector(
    (state: RootState, groupIds: number[] | undefined) => selectLicensesByGroupIds(state, groupIds),
    (licenses: License[]) => {
        if (!licenses.length) {
            return emptyDevices;
        }
        return licenses.map((license) => license.device).filter((device): device is Device => Boolean(device));
    },
);
const selectDevicesByLicenseIds = (state: RootState, licenseIds: number[]) => {
    const devices = defaultSelectors.selectAll(state);
    return devices.filter((device) => licenseIds.includes(device.licenseId));
};

const selectDevicesForSingleGroup = createSelector(
    (state: RootState, groupId: number) => selectLicensesByGroupId(state, groupId),
    (licenses: License[]) => {
        const devices = licenses.map((license) => license.device).filter((device): device is Device => Boolean(device));
        return devices.length ? devices : emptyDevices;
    },
);

const selectDevicesByGroupId = (state: RootState, groupId: number | undefined): Device[] =>
    groupId ? selectDevicesForSingleGroup(state, groupId) : emptyDevices;

export { selectDeviceById, selectDevicesByGroupId, selectDevicesByGroupIds, selectDevicesByLicenseIds };
